module.exports = __webpack_public_path__ + "img/has-purchase.0f72e0c3.svg";